module.exports = __webpack_public_path__ + "static/media/painting.57897daa.glb";


//////////////////
// WEBPACK FOOTER
// ./src/constants/painting.glb
// module id = 91
// module chunks = 0